import "./App.css";
//import { ReactComponent as WorkIcon } from "./work.svg";
//import { ReactComponent as SchoolIcon } from "./school.svg";
 
import timelineElements from "./timelineElements";

import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";

import "react-vertical-timeline-component/style.min.css";

function App() {
  let myIconStyles = { background: "#ffaa00" };
  //let schoolIconStyles = { background: "#ffaa00" };

  var pathpage = "./assets/pages/it/";
  var pathimage = "./assets/img/";
    
  return (
    <div>
      <h1 className="title">Alcune Milestones dell'informatica</h1>
      <VerticalTimeline>
        {timelineElements.map((element) => {
          //let isWorkIcon = element.icon === "";
          let showButton =
            element.buttonText !== undefined &&
            element.buttonText !== null &&
            element.buttonText !== "";

	    //iconStyle={isWorkIcon ? workIconStyles : schoolIconStyles}
	    //icon={isWorkIcon ? <WorkIcon /> : <SchoolIcon />
	
          return (
            <VerticalTimelineElement
              key={element.key}
              date={element.date}
              dateClassName="date"
              iconStyle={myIconStyles}

            >
              <h3 className="vertical-timeline-element-title">
                {element.title}
              </h3>
              <h5 className="vertical-timeline-element-subtitle">
                {element.location}
              </h5>
              <p id="description">{element.description}</p>
              {showButton && (
                <a
                 className={`button ${
                    "myButton"
                  }`}
                  href={pathpage + element.page}
                >
                  {element.buttonText}
                </a>
	      )}
		<p></p>
		<div><img id="pic" src={pathimage + element.image} alt="React Image"/></div>		      
            </VerticalTimelineElement>
          );
        })}
      </VerticalTimeline>
    </div>
  );
}



export default App;
